import { render } from "./HomeInso.vue?vue&type=template&id=8e49d6f8"
import script from "./HomeInso.vue?vue&type=script&lang=js"
export * from "./HomeInso.vue?vue&type=script&lang=js"

import "./HomeInso.vue?vue&type=style&index=0&id=8e49d6f8&lang=css"

import exportComponent from "/home/ammar/Downloads/inso_app/isoassurance/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__